import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { CheckoutService } from '../../shared/modules/checkout/checkout.service';
import { CustomProfileAndPreferencesService } from '../custom-profile-and-preferences.service';

@Component({
    selector: 'app-custom-profile-and-preferences',
    templateUrl: './custom-profile-and-preferences.component.html',
    styleUrls: ['./custom-profile-and-preferences.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class CustomProfileAndPreferencesComponent implements OnInit, OnDestroy {
  
  tabSelected = 'profile.userheading';
  selecTabVal = 'profile.userheading';
  smallerDevice: boolean;
  userData: any;

 tabDataArray = [
  { key: 'User', value: 'profile.userheading' },
  { key: 'Account', value: 'profile.accountheading' },
  { key: 'Payment', value: 'profile.paymentheading' },
];
  constructor(
    private readonly pfservice: CustomProfileAndPreferencesService,
    private readonly user: UserAccountFacade,
    private readonly checkoutService:CheckoutService
  ) {
    this.tabSelected = this.selecTabVal;
  }

  ngOnInit(): void {
    this.user.get().subscribe((data) => {
      if (data !== undefined) {
        this.userData = data;
        this.pfservice.getUserAccountDataFromDb(this.userData.userName);

      }
    });
   // document.getElementById('Account').style.display = 'none';
   // document.getElementById('Payment').style.display = 'none';
    this.checkoutService.tabselected$.subscribe((res: any) => {    
      if (res) {
        if (res === 'Account information' ||  res === 'Informations sur le compte') {
          this.tabSelected = 'profile.accountheading';
          //document.getElementById('Account').style.display = 'block';
          //document.getElementById('User').style.display = 'none';
          //document.getElementById('Payment').style.display = 'none';
        } else {
          this.tabSelected = 'profile.paymentheading';
          //document.getElementById('Account').style.display = 'none';
          //document.getElementById('User').style.display = 'none';
          //document.getElementById('Payment').style.display = 'block';
        } 
        this.checkoutService.tabselected.next(false);
      }
    });
    //=====================Commented for future purpose===========================================
  }

  ngOnDestroy() { }

   tabNavigationDropDown(): void {
    this.tabDataArray.forEach((data) => {
      if (data.value === this.tabSelected) {
        this.tabSelected = data.value;
        document.getElementById(data.key).style.display = 'block';
      } else {
        document.getElementById(data.key).style.display = 'none';
      }
    });
  }
  /*tabNavigation(content, id): void {
    const idArray = ['User', 'Account', 'Payment'];
    this.tabSelected = content;

    for (const item of idArray) {
      if (id === item) {
        this.pfservice.tabClicked.next(id);
        document.getElementById(item).style.display = 'block';
      } else {
        document.getElementById(item).style.display = 'none';
      }
    }
  }*/
    //ngOnDestroy(): void { }
 
    tabNavigation(content: string, id: string): void {
     this.tabSelected = content;
     this.pfservice.tabClicked.next(id);
   }
}
